import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, forwardRef } from '@angular/core';
import Cookies from 'js-cookie';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export const WITH_XDEBUG_INTERCEPTOR_PROVIDER = {
  provide: HTTP_INTERCEPTORS,
  useClass: forwardRef(() => WithXdebugInterceptor),
  multi: true,
};

@Injectable()
export class WithXdebugInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (typeof Cookies.get('XDEBUG_SESSION') !== 'undefined') {
      const params = {
        XDEBUG_SESSION: environment.xdebugKey,
      };
      request = request.clone({ setParams: params });
    }

    return next.handle(request);
  }
}
